import { render, staticRenderFns } from "./CustomerInvoicesSidebar.vue?vue&type=template&id=68661bb1&scoped=true&"
import script from "./CustomerInvoicesSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoicesSidebar.vue?vue&type=style&index=0&id=68661bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68661bb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68661bb1')) {
      api.createRecord('68661bb1', component.options)
    } else {
      api.reload('68661bb1', component.options)
    }
    module.hot.accept("./CustomerInvoicesSidebar.vue?vue&type=template&id=68661bb1&scoped=true&", function () {
      api.rerender('68661bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/CustomerInvoicesSidebar.vue"
export default component.exports